<template>
  <div class="pagebox_cbjj padding relative ">
    <el-tabs v-model="activeName" type="card" class="dn-content-bg" @tab-click="handleClick">
      <el-tab-pane class="texteltab" label="电" name="1">
        <div class="itemsLeft">
          <div class="itemgrounp">
            <div class="btnbox_">
              <el-button type="primary" size="small" v-popover:tlAddPop @click="eleclick('add')">新增</el-button>
              <el-button type="success" size="small" @click="eleclick('edit')">编辑</el-button>
              <el-button type="info" size="small" @click="eleDeleteClick">删除</el-button>
            </div>
            <div class="tablebox table-warp table-warp">
              <!-- :header-cell-style="tableHeaderColor" -->
              <el-table border ref="singleTable1" :data="leftTableEle" highlight-current-row height="100%" @row-click="rowselectChange" style="width:90%;margin-top:5px;">
                <template v-for="(item, index) in left_columns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :formatter="item.formatter?item.formatter :null"></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
          <div class="itemgrounp">
            <div class="elefeng" v-if="form.region=='1'">
              <div class="eletable table-warp">
                <p class="zt zt1">单价</p>
                <el-table :data="tableData2" border :fit=true style="width: 100%" height="20%" highlight-current-row size="small">
                  <el-table-column v-for="(item,index) in eleTopcolumns" :key="index" :label="item.label" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row['type'+index]"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="eletable eletable_ table-warp">
                <p class="zt zt1">时段</p>
                <el-table :data="tableData" border :fit=true style="width:100%" height="100%" highlight-current-row size="small">
                  <el-table-column v-for="(item,index) in eleBotcolumns" :key="index" :label="item.label" align="center">
                    <template slot-scope="scope">
                      <el-time-picker v-if="index==0" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index+1)]" value-format="HH:mm" format="HH:mm" placeholder="任意时间点">
                      </el-time-picker>
                      <el-time-picker v-if="index==1" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index-1)]" value-format="HH:mm" format="HH:mm" placeholder="任意时间点">
                      </el-time-picker>
                      <el-select v-if="index==2" v-model="scope.row['time'+index]" placeholder="请选择活动区域">
                        <el-option label="峰" value="1"></el-option>
                        <el-option label="平" value="2"></el-option>
                        <el-option label="谷" value="3"></el-option>
                        <el-option label="尖" value="4"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="{row,$index}">
                      <span class="addrow" @click="addrowtime">增加一行</span>
                      <span class="addrow" @click="delerowtime($index)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div calss="elebuy" v-if="form.region=='2'">
              <el-form ref="form" :model="elebuyform" label-width="80px">
                <el-form-item label="单价">
                  <el-input style="width:218px;" v-model="elebuyform.unitPrice"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <!-- 商业 -->

            <!-- 阶梯 -->
            <div calss="jieti table-warp" v-if="form.region=='3'">
              <el-table :data="tableData3" border :fit=true style="width: 100%" height="400px" highlight-current-row size="small">
                <el-table-column label="阀值" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row['jiti0']"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="单价" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row['jiti1']"></el-input>
                  </template>

                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="{scope,$index}">
                    <span class="addrow" @click="addrow">增加一行</span>
                    <span class="addrow" @click="delerowjieti($index)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="btnbox">
              <el-button type="primary" class="btn" @click="summit('ele')">保 存</el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane class="texteltab" label="水" name="2">
        <div class="itemsLeft">
          <div class="itemgrounp">
            <div class="btnbox_">
              <el-button type="primary" size="small" v-popover:tlAddPop @click="eleclick('add')">新增</el-button>
              <el-button type="success" size="small" @click="eleclick('edit')">编辑</el-button>
              <el-button type="info" size="small" @click="eleDeleteClick">删除</el-button>
            </div>
            <div class="tablebox table-warp">
              <el-table border ref="singleTable2" height="100%" :data="leftTableEle" highlight-current-row @row-click="rowselectChange" style="width:90%;margin-top:5px;">
                <template v-for="(item, index) in left_columns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :formatter="item.formatter?item.formatter :null"></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
          <div class="itemgrounp">
            <el-form ref="form" :model="waterform" :inline="true" label-width="120px">
              <el-form-item label="单价">
                <el-input v-model="waterform.unitPrice"></el-input>
              </el-form-item>
            </el-form>
            <div class="btnbox">
              <el-button type="primary" class="btn" @click="summit('water')">保 存</el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane class="texteltab" label="天然气" name="3">
        <div class="itemsLeft">
          <div class="itemgrounp">
            <div class="btnbox_">
              <el-button type="primary" size="small" v-popover:tlAddPop @click="eleclick('add')">新增</el-button>
              <el-button type="success" size="small" @click="eleclick('edit')">编辑</el-button>
              <el-button type="info" size="small" @click="eleDeleteClick">删除</el-button>
            </div>
            <div class="tablebox table-warp">
              <el-table border ref="singleTable3" height="100%" :data="leftTableEle" highlight-current-row :header-cell-style="tableHeaderColor" @row-click="rowselectChange" style="width:90%;margin-top:5px;">
                <template v-for="(item, index) in left_columns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :formatter="item.formatter?item.formatter :null"></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
          <div class="itemgrounp">
            <el-form ref="form" :model="lngform" :inline="true" label-width="120px">
              <el-form-item label="单价">
                <el-input v-model="lngform.unitPrice"></el-input>
              </el-form-item>
            </el-form>
            <div class="btnbox">
              <el-button type="primary" class="btn" @click="summit('lng')">保 存</el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane class="texteltab" label="柴油" name="4">
        <div class="itemsLeft">
          <div class="itemgrounp">
            <div class="btnbox_">
              <el-button type="primary" size="small" v-popover:tlAddPop @click="eleclick('add')">新增</el-button>
              <el-button type="success" size="small" @click="eleclick('edit')">编辑</el-button>
              <el-button type="info" size="small" @click="eleDeleteClick">删除</el-button>
            </div>
            <div class="tablebox table-warp">
              <el-table border ref="singleTable3" height="100%" :data="leftTableEle" highlight-current-row :header-cell-style="tableHeaderColor" @row-click="rowselectChange" style="width:90%;margin-top:5px;">
                <template v-for="(item, index) in left_columns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'" :formatter="item.formatter?item.formatter :null"></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
          <div class="itemgrounp">
            <el-form ref="form" :model="dieselform" :inline="true" label-width="120px">
              <el-form-item label="单价">
                <el-input v-model="dieselform.unitPrice"></el-input>
              </el-form-item>
            </el-form>
            <div class="btnbox">
              <el-button type="primary" class="btn" @click="summit('diesel')">保 存</el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 电弹窗 -->
    <el-dialog :title="title" :visible.sync="alarm" width="40%" :close-on-click-modal="false" @close="formClose">
      <el-form label-width="130px" :model="eleaddform" :rules="rules" ref="eleaddform">
        <el-form-item label="开始与结束时间:">
          <el-date-picker v-model="eleaddform.value1" value-format="yyyy/MM/dd HH:mm:ss" :unlink-panels="true" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="计价模型:" prop="region">
          <el-select v-model="eleaddform.region" :disabled="disabled " placeholder="请选择活动区域">
            <el-option v-for="(item,index) in tanType" :key="index" :label=item.text :value=item.type></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 峰平谷尖开始 -->
      <div class="elefeng" v-if="activeName=='1'&&eleaddform.region==1&&noModify">
        <div class="eletable table-warp">
          <p class="zt zt1">单价</p>
          <el-table :data="tableDataFpg" border :fit=true style="width: 100%" height="20%" highlight-current-row :header-cell-style="tableHeaderColor" size="small">
            <el-table-column v-for="(item,index) in eleTopcolumnsNew" :key="index" :label="item.label" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row['type'+index]"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="eletable eletable_ table-warp">
          <p class="zt zt1">时段</p>
          <el-table :data="tableDataFpgTime" border :fit=true style="width:100%" height="250px" highlight-current-row :header-cell-style="tableHeaderColor" size="small">
            <el-table-column v-for="(item,index) in eleBotcolumnsNew" :key="index" :label="item.label" align="center">
              <template slot-scope="scope">
                <el-time-picker v-if="index==0" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index+1)]" value-format="HH:mm" format="HH:mm" placeholder="任意时间点">
                </el-time-picker>
                <el-time-picker v-if="index==1" v-model="scope.row['time'+index]" :picker-options="scope.row['time'+(index-1)]" value-format="HH:mm" format="HH:mm" placeholder="任意时间点">
                </el-time-picker>
                <el-select v-if="index==2" v-model="scope.row['time'+index]" placeholder="请选择活动区域">
                  <el-option label="峰" value="1"></el-option>
                  <el-option label="平" value="2"></el-option>
                  <el-option label="谷" value="3"></el-option>
                  <el-option label="尖" value="4"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="{row,$index}">
                <span class="addrow" @click="addrowtime('dig')">增加一行</span>
                <span class="addrow" @click="delerowtime($index,'dig')">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 峰平谷尖结束 -->
      <!-- 商业开始 -->
      <div calss="elebuy" v-if="activeName=='1'&&eleaddform.region=='2'&&noModify||activeName=='2'&&eleaddform.region=='1'&&noModify
            ||activeName=='3'&&eleaddform.region=='1'&&noModify||activeName=='4'&&eleaddform.region=='1'&&noModify">
        <el-form ref="form" :model="elebuyformNew" label-width="80px">
          <el-form-item label="单价">
            <el-input style="width:218px;" v-model="elebuyformNew.unitPrice"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 商业结束 -->
      <!-- 阶梯开始 -->
      <div calss="jieti table-warp" v-if="activeName=='1'&&eleaddform.region=='3'&&noModify">
        <el-table :data="tableDataJt" border :fit=true style="width: 100%" height="400px" highlight-current-row size="small" :header-cell-style="tableHeaderColor">
          <el-table-column label="阀值" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row['jiti0']"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row['jiti1']"></el-input>
            </template>

          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{scope,$index}">
              <span class="addrow" @click="addrow('dig')">增加一行</span>
              <span class="addrow" @click="delerowjieti($index,'dig')">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 阶梯结束 -->
      <div slot="footer" class="dialog-footer" style="margin-right: 320px;">
        <el-button type="primary" @click="eleAddSave" class="btn">保 存</el-button>
        <el-button @click="alarm = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as utils from '@/utils/index.js'
export default {
  data () {
    return {
      activeName: '1',
      tableData: [{ time0: '', time1: '', time2: '' }],
      tableData2: [{ type0: '', type1: '', type2: '', type3: '' }],
      tableData3: [{ jiti0: '', jiti1: '' }],
      columns: [
        { prop: 'id', label: 'id', show: true },
        { prop: 'name', label: '名称', show: true },
      ],
      page: {
        pageSizes: [10, 20, 30, 40], //每页显示条目个数
        total: 50,
      },
      left_columns: [
        { prop: 'startDate', label: '开始时间', show: true },
        { prop: 'endDate', label: '结束时间', show: true },
        {
          prop: 'mode',
          label: '计价模型',
          show: true,
          formatter: this.Setformatter,
        },
      ],
      eleBotcolumns: [
        { id: 0, label: '开始时间', show: true },
        { id: 1, label: '结束时间', show: true },
        { id: 2, label: '峰平谷尖', show: true },
      ],
      eleBotcolumnsNew: [
        { id: 0, label: '开始时间', show: true },
        { id: 1, label: '结束时间', show: true },
        { id: 2, label: '峰平谷尖', show: true },
      ],
      eleTopcolumns: [
        { id: 0, label: '峰', show: true, formatter: 'formatterone' },
        { id: 1, label: '平', show: true },
        { id: 2, label: '谷', show: true },
        { id: 3, label: '尖', show: true },
      ],
      eleTopcolumnsNew: [
        { id: 0, label: '峰', show: true, formatter: 'formatterone' },
        { id: 1, label: '平', show: true },
        { id: 2, label: '谷', show: true },
        { id: 3, label: '尖', show: true },
      ],
      jieTicolumns: [
        { id: 0, label: '阀值', show: true },
        { id: 1, label: '单价', show: true },
      ],
      tanType: window.baseConfig.costData[0].modes,
      form: {
        region: '1',
      },
      elebuyform: {
        unitPrice: '',
      },

      waterform: {
        region: '2',
        unitPrice: '',
      },
      lngform: {
        region: 'sahngye',
        unitPrice: '',
      },
      dieselform: {
        region: '4',
        unitPrice: '',
      },
      eleUnitPrice: [], //获取电单价
      leftTableEle: [],
      title: '新增',
      alarm: false,
      value1: [],
      eleaddform: {
        region: '',
        value1: [],
      },
      rules: {
        region: [
          {
            required: true,
            message: '请选择计价模型',
            trigger: ['blur', 'change'],
          },
        ],
        value1: [
          {
            type: 'array',
            required: true,
            message: '请选择时间',
            trigger: ['blur', 'change'],
          },
        ],
      },
      selectRowsValue: null,
      rowselected: false,
      jjmode: window.baseConfig.costData[0].modes,
      jjmode2: window.baseConfig.costData[1].modes,
      handltype: '', //新增还是编辑状态
      disabled: false,
      elebuyformNew: {
        unitPrice: '',
      },
      rowParam: {},
      noModify: false,
    }
  },
  created () {
    this.getCostType()
  },
  watch: {
    activeName () {
      this.rowselected = false //选择状态职位false
      this.selectRowsValue = null //选择的行清空
      this.leftTableEle = [] //左边表格清空
      if (this.activeName == 1) {
        this.tanType = window.baseConfig.costData[0].modes
      } else {
        this.tanType = window.baseConfig.costData[1].modes
      }
      this.waterform.unitPrice = ''
      this.lngform.unitPrice = ''
      this.dieselform.unitPrice = ''
      this.elebuyform.unitPrice = ''
      this.getCostType()
    },
  },
  methods: {
    getCostType () {
      let this_ = this
      let companyId = 0,
        energyType = this.activeName
      this.$api.cost
        .getCompanyPricingModeOfEnergyCost(
          this.$store.state.user.currentCompanyId,
          energyType
        )
        .then((res) => {
          if (!res.success) {
            return
          }
          this_.leftTableEle = res.data
          if (!this.rowselected && !this.selectRowsValue) {
            this.serRowClick(res.data[0])
          }
        })
    },
    getBusiness () {
      //电=》商业单价
      let pricingRegulationId = this.selectRowsValue.id
      this.$api.cost
        .getCompanyElectricityPricingMode2(pricingRegulationId)
        .then((res) => {
          this.elebuyform.unitPrice = res.data.unitPrice
        })
    },
    eleclick (type) {
      //电左边表格添加
      this.handltype = type
      this.eleaddform = { region: '', value1: [] }
      if (type == 'add') {
        this.title = '新增'
        this.noModify = true
        this.alarm = true
        this.disabled = false
          ; (this.tableDataFpg = [{ type0: '', type1: '', type2: '', type3: '' }]),
            (this.tableDataFpgTime = [{ time0: '', time1: '', time2: '' }]),
            (this.tableDataJt = [{ jiti0: '', jiti1: '' }]),
            (this.elebuyformNew = {
              unitPrice: '',
            })
      } else {
        if (!this.rowselected) {
          this.showMsg('请选择要编辑的信息！')
          return
        }
        this.title = '编辑'
        this.noModify = false
        this.disabled = true
        this.eleaddform.region = this.selectRowsValue.mode
        this.eleaddform.value1 =
          this.selectRowsValue.startDate != null
            ? Array.of(
              this.selectRowsValue.startDate,
              this.selectRowsValue.endDate
            )
            : ''
        this.alarm = true
      }
      if (this.$refs['eleaddform']) {
        this.$refs['eleaddform'].resetFields()
      }
    },
    eleDeleteClick () {
      let this_ = this
      if (!this.rowselected) {
        this.showMsg('请选择要删除的信息！')
        return
      }
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let pricingRegulationId = this_.selectRowsValue.id
        this_.$api.cost
          .deleteCompanyPricingModeOfEnergyCost(pricingRegulationId)
          .then((res) => {
            this_.showMsg(res.msg)
            if (!res.success) {
              return
            }
            this_.waterform.unitPrice = ''
            this_.lngform.unitPrice = ''
            this_.dieselform.unitPrice = ''
            this_.form.region = ''
            this_.selectRowsValue = null
            this_.getCostType()
          })
      })
    },
    Setformatter (row, column, cellValue) {
      let value = cellValue
      let temparr = []
      if (this.activeName == 1) {
        temparr = JSON.parse(JSON.stringify(this.jjmode))
      } else {
        temparr = JSON.parse(JSON.stringify(this.jjmode2))
      }
      let temp = temparr.find((val, index) => {
        return cellValue == val.id
      })
      if (temp) {
        value = temp.text
      }

      if (this.activeName == '1') {
        if (value == '1') {
          value = '峰平谷尖'
        } else if (value == '2') {
          value = '商业'
        } else {
          value = '阶梯'
        }
      } else {
        value = '商业'
      }
      return value
    },
    rowselectChange (val) {
      this.rowselected = true
      this.serRowClick(val)
    },
    serRowClick (val) {
      let this_ = this
      this.rowParam = JSON.parse(val.pricingModelParams)
      this.selectRowsValue = val
      this.form.region = val.mode
      if (
        !this.rowselected &&
        !this.selectRowsValue &&
        this.leftTableEle.length != 0
      ) {
        let val = this_.leftTableEle[0]
        this_.selectRowsValue = val
        this_.form.region = val.mode
        this_.rowselected = true
        this_.$refs.singleTable1.setCurrentRow(this_.leftTableEle[0])
        this_.$refs.singleTable2.setCurrentRow(this_.leftTableEle[0])
        this_.$refs.singleTable3.setCurrentRow(this_.leftTableEle[0])
      }
      if (this.activeName == '1') {
        //电、峰评估的
        if (this.form.region == '1') {
          this.getElePeak()
        } else if (this.form.region == '2') {
          //电、商业的
          this.getEleBusiness()
        } else {
          this.getLadder()
        }
      } else if (this.activeName == '2') {
        this.getWaterPrice() //查水单价
      } else if (this.activeName == '3') {
        this.getLngPrice() //查气单价
      } else if (this.activeName == '4') {
        this.getDieselPrice() //查气单价
      }
    },
    /* h获取峰平谷数据  type确定峰平谷尖哪种数据 */
    getFPG (arr, res, type) {
      res.forEach((item) => {
        arr.push({
          ['time0']: item.startTime,
          ['time1']: item.endTime,
          ['time2']: type,
        })
      })
      return arr
    },
    getElePeak () {
      //电、峰平谷尖的数据获取
      let pricingRegulationId = this.selectRowsValue.id
      let temp = [{ type0: '', type1: '', type2: '', type3: '' }]
      temp[0].type0 = this.rowParam.unitPrice.peak
      temp[0].type1 = this.rowParam.unitPrice.plain
      temp[0].type2 = this.rowParam.unitPrice.valley
      temp[0].type3 = this.rowParam.unitPrice.sharp
      this.tableData2 = temp
      let testdata = this.rowParam.timeSegment
      let arr = []
      /* 峰 */
      this.getFPG(arr, testdata.peak, '1')
      /* 平 */
      this.getFPG(arr, testdata.plain, '2')
      /* 谷 */
      this.getFPG(arr, testdata.valley, '3')
      /* 尖 */
      arr = this.getFPG(arr, testdata.sharp, '4')
      if (arr.length == 0) {
        arr = [{ time0: '', time1: '', time2: '' }]
      }
      this.tableData = arr
    },
    getEleBusiness () {
      //查询电的商业
      this.elebuyform.unitPrice = this.rowParam.unitPrice
    },
    getLadder () {
      //查询电的阶梯
      let temp = this.rowParam.map((v) => {
        return { jiti0: v.thresholdValue, jiti1: v.unitPrice }
      })
      if (temp.length == 0) {
        temp = [{ jiti0: '', jiti1: '' }]
      }
      this.tableData3 = temp
    },
    getWaterPrice () {
      //查询水单价
      this.waterform = this.rowParam
      if (!this.rowParam) {
        this.waterform = {
          region: '2',
          unitPrice: '',
        }
      }
    },
    getLngPrice () {
      //查询天然气单价
      this.lngform = this.rowParam
      if (!this.rowParam) {
        this.waterform = {
          region: 'sahngye',
          unitPrice: '',
        }
      }
    },
    /*  查询柴油*/
    getDieselPrice () {
      this.dieselform = this.rowParam
      if (!this.rowParam) {
        this.dieselform = {
          region: '4',
          unitPrice: '',
        }
      }
    },
    /* 获取参数格式的数据  region计价模型 fUnitPrice  峰平谷单价 fTimeData  峰平谷时段    business 电商业数据  phase阶段数据 waterBusiness 水商业数据
    lingBusiness 气商业数据  dieselBusiness 柴油数据*/
    getParams (
      region,
      fUnitPrice,
      fTimeData,
      business,
      phase,
      waterBusiness,
      lingBusiness,
      dieselBusiness
    ) {
      let obj = {
        timeSegment: {
          peak: [], //峰
          plain: [], //平
          valley: [], //谷
          sharp: [], //尖
        },
        unitPrice: {
          peak: fUnitPrice.type0,
          plain: fUnitPrice.type1,
          valley: fUnitPrice.type2,
          sharp: fUnitPrice.type3,
        },
      }
      if (this.activeName == '1') {
        if (region == '1') {
          fTimeData.forEach((item) => {
            if (item.time2 == '1') {
              obj.timeSegment.peak.push({
                startTime: item.time0,
                endTime: item.time1,
              })
            } else if (item.time2 == '2') {
              obj.timeSegment.plain.push({
                startTime: item.time0,
                endTime: item.time1,
              })
            } else if (item.time2 == '3') {
              obj.timeSegment.valley.push({
                startTime: item.time0,
                endTime: item.time1,
              })
            } else {
              obj.timeSegment.sharp.push({
                startTime: item.time0,
                endTime: item.time1,
              })
            }
          })
        } else if (region == '2') {
          obj = business
        } else {
          obj = []
          phase.forEach((item) => {
            obj.push({
              thresholdValue: item.jiti0,
              unitPrice: item.jiti1,
            })
          })
        }
      } else if (this.activeName == '2') {
        //水
        obj = waterBusiness
      } else if (this.activeName == '3') {
        obj = { unitPrice: lingBusiness.unitPrice }
      } else if (this.activeName == '4') {
        obj = dieselBusiness
      }
      return obj
    },
    /* 外边缘保存 */
    eleAddSave () {
      this.$refs['eleaddform'].validate(async (valid) => {
        if (valid) {
          if (this.handltype == 'add') {
            let companyId = '0'
            let rentalAreaId = '0'
            let energyType = this.activeName
            let mode = this.eleaddform.region
            let startDate = this.eleaddform.value1[0]
            let endDate = this.eleaddform.value1[1]
            let obj = this.getParams(
              this.eleaddform.region,
              this.tableDataFpg[0],
              this.tableDataFpgTime,
              this.elebuyformNew,
              this.tableDataJt,
              this.elebuyformNew,
              this.elebuyformNew,
              this.elebuyformNew
            )
            let res = await this.$api.cost.addCompanyPricingModeOfEnergyCost(
              this.$store.state.user.currentCompanyId,
              rentalAreaId,
              energyType,
              mode,
              obj,
              startDate,
              endDate
            )
            this.getDataAfter(res)
          } else {
            //编辑计价模式
            let pricingRegulationId = this.selectRowsValue.id
            let startDate = this.eleaddform.value1[0]
            let endDate = this.eleaddform.value1[1]
            let res = await this.$api.cost.modifyCompanyPricingModeOfEnergyCost(
              pricingRegulationId,
              startDate,
              endDate
            )
            this.getDataAfter(res)
          }
        } else {
          return false
        }
      })
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #F3F3F3;color: #666;'
      }
    },
    formClose () { },
    handleClick (tab, event) { },
    handleSizeChange (val) { },
    addrow (type) {
      if (type == 'dig') {
        //弹窗内
        this.tableDataJt.push({ time0: '', time1: '', time2: '' })
      } else {
        this.tableData3.push({ jiti0: '', jiti1: '' })
      }
    }, //新增一行
    addrowtime (type) {
      if (type == 'dig') {
        //弹窗内
        this.tableDataFpgTime.push({ time0: '', time1: '', time2: '' })
      } else {
        this.tableData.push({ time0: '', time1: '', time2: '' })
      }
    },
    delerowtime (row, type) {
      //删除一行
      if (type == 'dig') {
        //弹窗内
        if (this.tableDataFpgTime.length == 1) {
          return
        }
        // this.tableDataFpgTime.splice(row, 1)
      } else {
        if (this.tableData.length == 1) {
          return
        }
        // this.tableData.splice(row, 1)
      }

      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (type == 'dig') {
          //弹窗内
          this.tableDataFpgTime.splice(row, 1)
        } else {
          this.tableData.splice(row, 1)
          this.deleTimeRow()
        }
      })
    },
    delerowjieti (row, type) {
      if (type == 'dig') {
        //弹窗内
        if (this.tableDataJt.length == 1) {
          return
        }
      } else {
        this.tableData.push({ time0: '', time1: '', time2: '' })
        if (this.tableData3.length == 1) {
          return
        }
      }
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (type == 'dig') {
          //弹窗内
          this.tableDataJt.splice(row, 1)
        } else {
          this.tableData3.splice(row, 1)
        }
      })
    },
    deleTimeRow () {
      //时段
      let pricingRegulationId = this.selectRowsValue.id
      let timeSet = this.tableData.map((v) => {
        return { type: v.time2, startTime: v.time0, endTime: v.time1 }
      })
      let havnull = timeSet.some(
        (v) => v.type == '' || v.startTime == '' || v.endTime == ''
      )
      if (havnull) {
        this.showMsg('时段不能为空')
        return
      }
      this.$api.cost
        .setCompanyElectricityPricingMode1TimeRange(
          pricingRegulationId,
          timeSet
        )
        .then((res) => {
          if (!res.success) {
            return
          }
          this.showMsg('设置成功')
        })
    },
    summit (type) {
      if (!this.selectRowsValue || this.selectRowsValue.length == 0) {
        this.showMsg('请先选择计价模型')
        return
      }
      let pricingRegulationId = this.selectRowsValue.pricingModelParamsId
      let obj = this.getParams(
        this.form.region,
        this.tableData2[0],
        this.tableData,
        this.elebuyform,
        this.tableData3,
        this.waterform,
        this.lngform,
        this.dieselform
      )
      this.$api.cost
        .modifyPricingModelParams(pricingRegulationId, JSON.stringify(obj))
        .then((res) => {
          if (res.success) {
            this.showMsg('设置成功')
          }
        })
    },
    showMsg (msg) {
      this.$notify({
        title: '提示',
        message: `${msg}`,
        type: 'warning',
      })
    },
    getDataAfter (res) {
      this.alarm = false
      if (!res.success) {
        return
      }
      this.rowselected = false
      this.selectRowsValue = null

      this.getCostType()
    },
  },
}
</script>
<style lang="scss">
.pagebox_cbjj {
  .el-tabs.el-tabs--card.el-tabs--top {
    height: 100% !important;
    position: relative !important;
    border-radius: 4px;
    // background-color: #fff;
  }
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 14px;
  box-sizing: border-box;
  .texteltab {
    height: 100%;
  }
  .itemsLeft {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
  }
  .itemgrounp {
    height: 100%;
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    .tablebox {
      position: absolute;
      top: 55px;
      bottom: 10px;
      width: 100%;
      /* div {
        height: 100% !important;
      } */
    }
    .elefeng {
      flex: 1;
    }
  }
  .relative {
    position: relative;
  }
  .el-tabs__content {
    position: absolute !important;
    top: 45px;
    width: 100%;
    bottom: 5px;
  }
  .box-card .el-tabs__item.is-top:last-child {
    color: #ff4949;
  }
  .pricebtnbox {
    width: 100%;
    padding: 14px;
    text-align: center;
  }
  .btnbox {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }
  .btnbox_ {
    width: 90%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
  }
  .eletable {
    margin-top: 10px;
    p {
      font-size: 14px;
    }
  }
  .eletable_ {
    height: 60%;
    /* div{
      height: 100% !important;
    } */
  }
  .itemgroup {
    width: 100%;
    position: absolute;
    top: 100px;
    bottom: 10px;
  }
  .addrow {
    color: #409eff;
    cursor: pointer;
    display: inline-block;
    margin: 5px 5px;
  }

  .el-table .cell {
    text-overflow: clip !important;
  }
}
.zt1 {
  color: #000;
}
.dn-content-bg {
  background-color: #fff;
}
</style>